import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

export const SettingsContainer = styled.div`
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
    background-color: #fafafa;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 16px;
    }
`;

export const SwitchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background-color: #fff;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 12px;
    }
`;

export const LocationFieldsHint = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 14px;
    margin-bottom: 16px;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    background-color: #e6f7ff;
    color: rgba(0, 0, 0, 0.65);
    font-size: 13px;
    line-height: 1.5715;

    .hint-icon {
        color: #1890ff;
        font-size: 16px;
        margin-top: 2px;
        flex-shrink: 0;
    }
`;
